import { render, staticRenderFns } from "./ComandaVirtual.vue?vue&type=template&id=688e2565"
import script from "./ComandaVirtual.vue?vue&type=script&lang=js"
export * from "./ComandaVirtual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports